import React from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import TextView from "../../TextView";
import { colors } from "../../../utils";

const StyledButton = styled(Button)(({ theme, customStyles }) => ({
  textTransform: "none",
  padding: "2px 10px",
  // DL-004 (ISP-4018): default hover BEFORE the spread, so a caller-supplied
  // "&:hover" in customStyles is honored instead of silently clobbered (it
  // previously never applied — the wrapper's own hover key always won).
  // Callers without a hover keep the old behavior (hover == rest fill).
  "&:hover": {
    backgroundColor: customStyles.backgroundColor || "none",
  },
  ...customStyles,
}));

const ReusableButton = ({
  onClick,
  text,
  variant = "contained",
  color = "primary",
  size = "medium",
  customStyles = {},
  textColor = colors.white,
  ...props
}) => {
  return (
    <StyledButton
      onClick={onClick}
      variant={variant}
      color={color}
      size={size}
      customStyles={customStyles}
      {...props}
    >
      <TextView variant="largeText" color={textColor}>
        {text}
      </TextView>
    </StyledButton>
  );
};

ReusableButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  color: PropTypes.oneOf(["default", "inherit", "primary", "secondary"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  customStyles: PropTypes.object,
};

export default ReusableButton;
